import React from 'react';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import cn from '../../../../lib/bem';
import ico_exito from './../../../../assets/icons/ico_exito.svg';
import ButtonComponent from '../../../../components/button/button_component';

import './infoDevRegExito.scss';

const InfoDevRegExito = () => {
    
    const history = useNavigate();
    const classes  = cn("infoDevRegExito");

    const endosoPoliza  = useSelector((state) => state.rootReducers.endosoPoliza);
 
    return (
        <div className={classes()}>
           <div className={classes('container')}>
                <img src={ico_exito} alt='exito' />
                <p><b>¡Tu informaci&oacute;n ha sido registrada con &eacute;xito!</b></p>
                <br/>
                <p>
                    Se ha ingresado el registro con el n&uacute;mero de atenci&oacute;n { endosoPoliza.numeroSolicitudServicio }. Si deseas hacer seguimiento puedes hacerlo con este c&oacute;digo a trav&eacute;s de nuestros canales de atenci&oacute;n.
                    <br/><br/>
                    Te estaremos confirmando por correo electr&oacute;nico cuando inicie el proceso de abono cuenta. Recuerda que el abono se realizar&aacute; dentro de los 30 d&iacute;as calendario siguientes a la finalizaci&eacute;n de tu poliza.
                </p>
                <br/>
                <div className={classes('btnContinuarExito')}>
                    <ButtonComponent label={'btnContinuar'} nombre={'Continuar'} tipo={'button-red'} action={() => history('/')} disabled={false}/>
                </div>
           </div>
        </div>
    );
};

export default InfoDevRegExito;
